/* eslint-disable react/require-default-props */

import React, { PropsWithChildren } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import Tooltip from 'components/Typography/Tooltip';

import './index.scss';

export type TooltipPlacement = 'top' | 'bottom' | 'left' | 'right';
export type TooltipArrowPlacement = 'left' | 'center' | 'right';

interface TooltipProps {
  title: string
  placement?: TooltipPlacement;
  arrowPlacement?: TooltipArrowPlacement;
  className?: string
  id?: string | undefined
  /**
   * Fecha a dica com Esc (e com clique fora), sem tirar o foco do alvo: atende a parte
   * "dispensável" do WCAG 1.4.13. Opcional para não mudar os tooltips que já existem.
   */
  dismissOnEscape?: boolean
}

export default function TooltipWrapper({
  children,
  title,
  placement = 'top',
  arrowPlacement = 'center',
  className = '',
  id = undefined,
  dismissOnEscape = false,
}: PropsWithChildren<TooltipProps>) {
  return (
    <OverlayTrigger
      placement={placement}
      rootClose={dismissOnEscape}
      overlay={(
        <div className={`ds-tooltip-container ds-tooltip-${placement}`}>
          <Tooltip>{title}</Tooltip>
          <div className={`ds-tooltip-arrow-wrapper ds-tooltip-arrow-wrapper-${arrowPlacement}`}>
            <div className="ds-tooltip-arrow-scaler">
              <div className="ds-tooltip-arrow" />
            </div>
          </div>
        </div>
      )}
    >
      {(props) => (
        <div
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          className={`d-inline-block ${className}`}
          id={id}
        >
          {children}
        </div>
      )}
    </OverlayTrigger>
  );
}
